(function (angular) {
    angular.module('bizPartEngage').controller('modules.blogs.list', blogsListController);
    angular.module('bizPartEngage').controller('modules.blogs.show', blogsShowController);
    angular.module('bizPartEngage').controller('modules.blogs.showbytag', blogsShowByTagController);

    blogsListController.$inject = ["$scope", "modules.blog.service", "$translate", "MetadataService", "$filter", "bizCoreService", "container", "bizEngageService", "$stateParams"];
    blogsShowController.$inject = ["$rootScope", "modules.blog.service", "$stateParams", "MetadataService", "container",
        "bizContainerSettings", "bizEngageService", "bizCoreService", "$filter", "bizRuntimeContainerService", "bizPageSurfaceService"];
    blogsShowByTagController.$inject = ["$rootScope", "modules.blog.service", "$stateParams", "MetadataService", "bizEngageService", "$filter", "bizRuntimeContainerService"];

    function blogsListController($scope, blogService, $translate, MetadataService, $filter, bizCoreService, container, bizEngageService, $stateParams) {
        var vm = this;

        vm.BlogItems = [];
        vm.AllBlogItems = [];
        vm.GUISettings = {};

        vm.GetBlogEntries = GetBlogEntries;
        vm.GetSettings = GetSettings;
        vm.ApplyTagFilter = ApplyTagFilter;

        vm.SortMostCommented = SortMostCommented;
        vm.SortMostLiked = SortMostLiked;

        vm.TagId = undefined;
        vm.CategoryId = GetCategoryId($stateParams.categoryId);

        function GetCategoryId(categoryId) {
            var parsedCategoryId = parseInt(categoryId, 10);
            return parsedCategoryId > 0 ? parsedCategoryId : undefined;
        }

        function SortMostCommented() {
            var items = angular.copy(vm.BlogItems);
            vm.BlogItemsCommented = items.sort(function (a, b) { return b.Comments.length - a.Comments.length }).slice(0, 6);
        }

        function SortMostLiked() {
            var items = angular.copy(vm.BlogItems);
            vm.BlogItemsLiked = items.sort(function (a, b) { return b.LikeValue - a.LikeValue }).slice(0, 6);
        }

        function GetBlogEntries(ignoreLoader) {            
            var bsMethod = blogService.GetNewestBlogEntries;
            var categoryIds = vm.CategoryId ? [vm.CategoryId] : undefined;
            if (journeySettings?.UseJourneyOrderInLists?.GetItemByValue('Key', 2)?.Value) {
                bsMethod = blogService.GetBlogEntriesByJourneyOrder;
            }            
            bsMethod(0, true, ignoreLoader, undefined, -1, categoryIds).then(GetBlogEntriesSuccess);
            function GetBlogEntriesSuccess(response) {
                vm.ItemsFetched = true;
                vm.AllBlogItems = response.data || [];
                vm.BlogItems = vm.AllBlogItems;

                //Populate Images and description
                HandleBlogData();
                vm.ApplyTagFilter();
            }
        }

        function ApplyTagFilter() {
            if (!vm.TagId) {
                vm.BlogItems = vm.AllBlogItems || [];
            } else {
                vm.BlogItems = (vm.AllBlogItems || []).filter(function (item) {
                    return HasTag(item, vm.TagId);
                });
            }

            vm.SortMostLiked();
            vm.SortMostCommented();
        }

        function HasTag(item, tagId) {
            if (!item) return false;

            var normalizedTagId = parseInt(tagId, 10);
            if (!normalizedTagId) return false;

            if (item.TagIds && item.TagIds.length > 0) {
                for (var j = 0; j < item.TagIds.length; j++) {
                    if (parseInt(item.TagIds[j], 10) === normalizedTagId) {
                        return true;
                    }
                }
            }

            return false;
        }

        function HandleBlogData() {
            for (var i = 0; i < vm.BlogItems.length; i++) {
                if (vm.BlogItems[i].ContainerId > 0) {
                    vm.BlogItems[i].Container = new container(vm.BlogItems[i].Container);
                    var modules = vm.BlogItems[i].Container.getModules("Image");
                    if (modules && modules.length > 0) {
                        vm.BlogItems[i].ImageUrl = modules[0].Content.ImageUrl;
                    }
                    else {
                        var modules = vm.BlogItems[i].Container.getModules("Video");
                        if (modules && modules.length > 0) {
                            if (vm.BlogItems[i].ImageUrl)
                                vm.BlogItems[i].ImageUrl = modules[0].Content.VideoUrl.replace('~/', "") + ".jpg";
                            else
                                vm.BlogItems[i].ImageUrl = "https://img.youtube.com/vi/" + modules[0].Content.YoutubeId + "/0.jpg";
                        }
                    }

                    if (vm.BlogItems[i].Description == null || vm.BlogItems[i].Description == "") {
                        var modules = vm.BlogItems[i].Container.getModules("Text");
                        if (modules != null && modules.length > 0) {
                            vm.BlogItems[i].Description = $filter('bizPlaceholders')(modules[0].Content.Text);
                        }
                    }
                }
                //vm.InitSlick(vm.BlogItems[i], 2);
                vm.BlogItems[i].DisplayDates = FormatCreatedUpdatedDateDisplay(vm.BlogItems[i].Created, vm.BlogItems[i].Updated);
            }
        }

        function GetSettings() {
            bizCoreService.Admin.GetGenericSetting("BLOG", "GUI_SETTINGS", 0).then(GetSettingsSuccess);

            function GetSettingsSuccess(response) {
                if (response.data && response.data.Value) {
                    vm.GUISettings = JSON.parse(response.data.Value);

                    if (vm.GUISettings.RelatedSettings && vm.SelectedItem) {
                        vm.GUISettings.RelatedSettings.RelatedId = vm.SelectedItem.Id;
                    }
                }
            }
        }

        function Init() {
            vm.GetBlogEntries();
            vm.GetSettings();

            $translate(['BLOG.META.TITLE', 'BLOG.META.DESCRIPTION']).then(function (translations) {
                MetadataService.setMetaTags({
                    title: translations['BLOG.META.TITLE'],
                    description: translations['BLOG.META.DESCRIPTION']
                })
            });

            bizEngageService.GetMiniJourneySetting('Blog').then(function (response) {
                vm.MiniJourneySettings = response;
            });

            $scope.$watch(function () {
                return vm.TagId;
            }, function (newVal, oldVal) {
                if (newVal === oldVal) return;

                vm.ApplyTagFilter();
            });
        }

        vm.$onInit = Init;
    }

    function blogsShowController($rootScope, blogService, $stateParams, MetadataService, container,
        bizContainerSettings, bizEngageService, bizCoreService, $filter, bizRuntimeContainerService, bizPageSurfaceService) {
        var vm = this;
        vm.SelectedItem = {};
        vm.EventSource = "BLOG";
        vm.ContainerVersion = 1;
        bizContainerSettings.ContainerRefererType = "BLOG";
        bizContainerSettings.ContainerRefererObjectId = vm.EntryId;
        vm.Preview = getParameterByNameFromUrl('preview', window.location.href) === 'true';

        vm.EntryTitle = $stateParams.title;

        vm.GetOneBlogEntry = GetOneBlogEntry;
        vm.GetDate = GetDate;

        function GetDate(date) {
            var momentDate = moment(date);
            if (momentDate.isValid() && (momentDate.hours() > 0 || momentDate.minutes() > 0))
                return moment(date).format('dddd D MMM YYYY HH:mm');
            else
                return moment(date).format('dddd D MMM YYYY');
        }

        function GetOneBlogEntry() {
            vm.AllItemsFetched = true;

            //handle if we give it the ID instead of the urlRewrite.
            if (~~vm.EntryTitle > 0) {                
                blogService.GetOneBlogEntry(~~vm.EntryTitle, vm.Preview).then(GetOneBlogEntrySuccess, GetOneBlogEntryError);
            } else {
                blogService.GetOneBlogEntryByTitle(vm.EntryTitle).then(GetOneBlogEntrySuccess, GetOneBlogEntryError);
            }

            function GetOneBlogEntryError(err) {
                if (err.status == 401 || err.status == 404 || err.status == 500)
                    vm.NoAccess = true;
            }

            function GetOneBlogEntrySuccess(response) {
                var blogItem = response.data;
                vm.EntryId = blogItem.Id;
                bizContainerSettings.ContainerRefererObjectId = vm.EntryId;
                bizContainerSettings.ContainerRefererCreatedByUserId = blogItem.UserId;
                vm.ItemsFetched = true
                vm.GettingMoreItems = false;

                blogItem.DisplayDates = FormatCreatedUpdatedDateDisplay(blogItem.Created, blogItem.Updated);
                var containerInfo = bizRuntimeContainerService.PrepareContainer(blogItem.Container);
                blogItem.Container = containerInfo.Container;
                vm.ContainerVersion = containerInfo.Version;
                bizPageSurfaceService.ApplyFromContainer(blogItem.Container);

                if (!containerInfo.IsV2 && blogItem.Container) {
                    bizEngageService.HandleContainer(blogItem.Container, blogItem.Id, bizEngageService.Types.Blog, 7, vm.EventSource);
                }

                vm.SelectedItem = blogItem;

                HandleMetaData();
                GetSettings();                
            }
        }

        function HandleMetaData() {
            var imageUrl = vm.SelectedItem.ImageUrl || bizRuntimeContainerService.GetImageUrl(vm.SelectedItem.Container, vm.ContainerVersion);
            var videoUrl = bizRuntimeContainerService.GetVideoUrl(vm.SelectedItem.Container, vm.ContainerVersion);

            MetadataService.setMetaTags({
				title: vm.SelectedItem.SeoTitle || vm.SelectedItem.Title,
				description: vm.SelectedItem.SeoDescription || vm.SelectedItem.Description,
				keywords: vm.SelectedItem.SeoKeywords,
                img: imageUrl,
                video: videoUrl,
                type: 'article',
                canonicalPath: vm.SelectedItem.CanonicalPath || '/blog/' + (vm.SelectedItem.UrlRewrite || vm.EntryTitle),
                excludeFromExternalIndex: vm.SelectedItem.ExcludeFromExternalIndex,
				datePublished: vm.SelectedItem.StartTimeUtc || vm.SelectedItem.Created,
				dateModified: vm.SelectedItem.Updated,
				author: vm.SelectedItem.UserFullName,
				estimatedTimeInMinutes: vm.SelectedItem.EstimatedTimeInMinutes
            });
        }

        function GetSettings() {
            bizCoreService.Admin.GetGenericSetting("BLOG", "GUI_SETTINGS", 0).then(GetSettingsSuccess);

            function GetSettingsSuccess(response) {
                if (response.data && response.data.Value) {
                    vm.GUISettings = JSON.parse(response.data.Value);

                    if (vm.GUISettings.RelatedSettings) {
                        vm.GUISettings.RelatedSettings.RelatedId = vm.SelectedItem.Id;
                    }
                }
            }
        }        

        function Init() {
            vm.GetOneBlogEntry();

            bizEngageService.GetMiniJourneySetting('Blog').then(function (response) {
                vm.MiniJourneySettings = response;
            });
        }

        vm.$onInit = Init;
    }

    function blogsShowByTagController($rootScope, blogService, $stateParams, MetadataService, bizEngageService, $filter, bizRuntimeContainerService) {
        var vm = this;

        var categoryId = parseInt($stateParams.categoryId, 10);
        vm.CategoryId = categoryId > 0 ? categoryId : undefined;
        vm.TagSystemName = $stateParams.tagSystemName;
        vm.BlogPostUrlRewrite = $stateParams.blogPostUrlRewrite;

        vm.SelectedItem = null;
        vm.EntriesPerPage = 10;

        vm.GetTag = GetTag;
        vm.GetMoreItems = GetMoreItems;
        vm.PopulateContainer = PopulateContainer;
        vm.SetSelectedItem = SetSelectedItem;

        function GetTag(callback) {
            if (vm.TagSystemName) {
                blogService.GetTagBySystemName(vm.TagSystemName).then(GetTagSuccess);
            } else {
                blogService.GetTag(vm.TagId).then(GetTagSuccess);
            }

            function GetTagSuccess(response) {
                vm.SelectedTag = vm.TagSystemName ? response.data : response.data[0];
                vm.TagId = vm.SelectedTag ? vm.SelectedTag.Id : undefined;
                vm.Tag = response.data || response.data[0];

                if (vm.Tag.length > 0) {
                    MetadataService.setMetaTags({
                        title: vm.Tag.Name,
                        description: vm.Tag.Description
                    });
                }

                if (callback) {
                    callback();
                }
            }
        }

        function GetBlogEntries(ignoreLoader) {
            var tagIds = vm.TagId ? [vm.TagId] : undefined;
            var categoryIds = [];

            if (typeof CustomBlogTagFilter === 'function') {
                tagIds = CustomBlogTagFilter($rootScope.CurrentState, tagIds);
            }

            if (typeof CustomBlogCategoryFilterFn === 'function') {
                categoryIds = CustomBlogCategoryFilterFn($rootScope.CurrentState);
            }

            blogService.GetNewestBlogEntries(0, true, ignoreLoader, tagIds, -1, categoryIds).then(GetBlogEntriesSuccess);
            function GetBlogEntriesSuccess(response) {
                vm.ItemsFetched = true;
                vm.BlogItems = response.data;
                vm.GettingMoreItems = false;
                vm.TotalEntries = vm.EntriesPerPage;
                vm.BlogItemsToShow = vm.BlogItems.slice(0, vm.EntriesPerPage);
                vm.AllItemsFetched = vm.TotalEntries >= vm.BlogItems.length;

                HandleBlogPosts();
            }
        }

        function GetMoreItems() {
            vm.BlogItemsToShow = vm.BlogItems;
            vm.TotalEntries = vm.BlogItems.length;
            vm.AllItemsFetched = true;
        }

        function SetSelectedItem(entry) {
            vm.BlogItems.map((e) => {
                e.Selected = false;
                if (e !== entry) e.Expanded = false;
            });
            entry.Selected = true;

            vm.SelectedItem = entry;
        }

        function PopulateContainer(entry) {
            /*console.log(entry);*/
            if (entry.Container == null || entry.Container.Id === -1) {
                blogService.GetOneBlogEntry(entry.Id).then((response) => {
                    var blogItem = response.data;
                    var containerInfo = bizRuntimeContainerService.PrepareContainer(blogItem.Container);
                    entry.Container = containerInfo.Container;
                    entry.ContainerVersion = containerInfo.Version;

                    entry.Expanded = !entry.Expanded;
                });
            }
            else {
                entry.Expanded = !entry.Expanded;
            }

            vm.SetSelectedItem(entry);
        }

        function HandleBlogPosts() {
            //Populate Images and description
            for (var i = 0; i < vm.BlogItems.length; i++) {
                if (vm.BlogItems[i].ContainerId > 0 && vm.BlogItems[i].Container) {
                    var containerInfo = bizRuntimeContainerService.PrepareContainer(vm.BlogItems[i].Container);
                    vm.BlogItems[i].Container = containerInfo.Container;
                    vm.BlogItems[i].ContainerVersion = containerInfo.Version;

                    if (containerInfo.IsV2) {
                        vm.BlogItems[i].ImageUrl = bizRuntimeContainerService.GetImageUrl(
                            vm.BlogItems[i].Container,
                            vm.BlogItems[i].ContainerVersion
                        ) || vm.BlogItems[i].ImageUrl;
                    }
                    else {
                        var modules = vm.BlogItems[i].Container.getModules("Image");
                        if (modules && modules.length > 0) {
                            vm.BlogItems[i].ImageUrl = modules[0].Content.ImageUrl;
                        }
                        else {
                            modules = vm.BlogItems[i].Container.getModules("Video");
                            if (modules && modules.length > 0) {
                                if (vm.BlogItems[i].ImageUrl)
                                    vm.BlogItems[i].ImageUrl = modules[0].Content.VideoUrl.replace('~/', "") + ".jpg";
                                else
                                    vm.BlogItems[i].ImageUrl = "https://img.youtube.com/vi/" + modules[0].Content.YoutubeId + "/0.jpg";
                            }
                        }

                        if (vm.BlogItems[i].Description == null || vm.BlogItems[i].Description == "") {
                            modules = vm.BlogItems[i].Container.getModules("Text");
                            if (modules != null && modules.length > 0) {
                                vm.BlogItems[i].Description = $filter('bizPlaceholders')(modules[0].Content.Text);
                            }
                        }
                    }
                }

                vm.BlogItems[i].DisplayDates = FormatCreatedUpdatedDateDisplay(vm.BlogItems[i].Created, vm.BlogItems[i].Updated);
            }

            if (typeof CustomHandleBlogPostsFn === 'function') {
                vm.BlogItems = CustomHandleBlogPostsFn($rootScope.CurrentState, $stateParams, vm.BlogItems, PopulateContainer);
            }
        }

        function Init() {
            vm.GetTag(GetBlogEntries);

            bizEngageService.GetMiniJourneySetting('Blog').then(function (response) {
                vm.MiniJourneySettings = response;
            });
        }

        $rootScope.$on('selected-tag-changed', function (event, args) {
            if (args.tag && args.tag.Id > -1 && vm.TagSystemName != args.tag.SystemName) {
                vm.TagSystemName = args.tag.SystemName;
                vm.TagId = args.tag.Id;

                GetBlogEntries();
            }
            else if (args && args.tag === null) {
                vm.TagSystemName = '';
                vm.TagId = undefined;

                GetBlogEntries();
            }
        })

        vm.$onInit = Init;
    }

    //DEPRECATED
    angular.module('bizPartEngage').controller('modules.blog', blogController);
    blogController.$inject = ["modules.blog.service", "$stateParams", "$sce", "container", "$timeout", "$mdDialog",
        "MetadataService", "$filter", "$translate", "$rootScope", "bizContainerSettings", "bizSocialShareService",
        "$state", "bizEngageService", "bizCoreService"];
    function blogController(blogService, $stateParams, $sce, container, $timeout, $mdDialog,
        MetadataService, $filter, $translate, $rootScope, bizContainerSettings, bizSocialShareService,
        $state, bizEngageService, bizCoreService) {

        var vm = this;
        vm.BlogItems = [];
        vm.EntryId = ~~$stateParams.id;
        vm.EntryTitle = $stateParams.title;
        vm.TagId = ~~$stateParams.tagId;
        vm.TagSystemName = $stateParams.tagSystemName;
        vm.GUISettings = {};

        vm.GetBlogEntries = GetBlogEntries;
        vm.TotalLikeActions = TotalLikeActions;
        vm.GetLikeActionsByValue = GetLikeActionsByValue;
        vm.PerformLikeAction = PerformLikeAction;
        vm.ExpandItem = ExpandItem;
        vm.GetImageUrl = GetImageUrl;
        vm.GetDate = GetDate;
        vm.InitSlick = InitSlick;
        vm.GetMoreItems = GetMoreItems;
        vm.GetOneBlogEntry = GetOneBlogEntry;
        vm.GetTimeTo = GetTimeTo;
        vm.StartEducation = StartEducation;
        vm.IsUnpublished = IsUnpublished;
        vm.NavigateToBlogEntry = NavigateToBlogEntry;
        vm.RedirectToUrlRewrite = RedirectToUrlRewrite;

        vm.GetRelatedBlogEntries = GetRelatedBlogEntries;
        vm.GetTag = GetTag;

        bizContainerSettings.ContainerRefererType = "BLOG";
        bizContainerSettings.ContainerRefererObjectId = vm.EntryId;

        vm.EntriesPerPage = 10;
        vm.TotalEntries = vm.EntriesPerPage;

        vm.AddBlogComment = AddBlogComment;

        vm.NotVisible = NotVisible;

        vm.GetSettings = GetSettings;

        function GetSettings() {
            bizCoreService.Admin.GetGenericSetting("BLOG", "GUI_SETTINGS", 0).then(GetSettingsSuccess);

            function GetSettingsSuccess(response) {
                if (response.data && response.data.Value) {
                    vm.GUISettings = JSON.parse(response.data.Value);

                    if (vm.GUISettings.RelatedSettings) {
                        vm.GUISettings.RelatedSettings.RelatedId = vm.SelectedItem.Id;
                    }
                }
            }
        }

        function NotVisible(item) {
            var now = moment();
            var expire = moment(item.ExpireDate);
            var publish = moment(item.PublishDate);

            if (publish > now || (moment(expire).isValid() && expire < now))
                return true;
        }

        function GetTag(callback) {
            if (vm.TagSystemName) {
                blogService.GetTagBySystemName(vm.TagSystemName).then(GetTagSuccess);
            } else {
                blogService.GetTag(vm.TagId).then(GetTagSuccess);
            }

            function GetTagSuccess(response) {
                vm.SelectedTag = vm.TagSystemName ? response.data : response.data[0];
                vm.TagId = vm.SelectedTag.Id;

                if (callback) {
                    callback();
                }
            }
        }

        function AddBlogComment(item) {
            if (item && $root.LoggedInUser.Id > 0)
                blogService.AddBlogComment(vm.NewComment, item.Id).then(AddBlogCommentSuccess);
            if (!item.Comments)
                item.Comments = [];

            function AddBlogCommentSuccess(response) {
                item.Comments.push(response.data);
                vm.NewComment = undefined;
            }
        }

        function StartEducation(education) {
            window.open(education.Url, '_blank');
        }

        function GetTimeTo(date) {
            var now = moment();
            var then = moment(date);
            var hours = moment.duration(then.diff(now)).asHours();
            return Math.round(hours);
        }

        function GetMoreItems() {
            vm.GettingMoreItems = true;
            vm.TotalEntries += vm.EntriesPerPage;
            vm.BlogItemsToShow = vm.BlogItems.slice(0, vm.TotalEntries)
            vm.AllItemsFetched = vm.TotalEntries > vm.BlogItems.length;
            vm.GettingMoreItems = false;
        }

        function GetDate(date) {            
            return moment(date).format('dddd D MMM YYYY HH:mm');
        }

        function PerformLikeAction(item, action) {
            if (!action.LikeActionPerformedByUser) {
                blogService.AddLikeActionToBlogEntry(item.Id, action.Action.Id).then(AddLikeActionToBlogEntrySuccess);
            }

            function AddLikeActionToBlogEntrySuccess(response) {
                action.LikeActionPerformedByUser = true; // changed from item
                action.Count++;

                var totalCount = 0;
                var totalValue = 0;

                for (var i = 0; i < item.LikeActions.length; i++) {
                    totalCount += item.LikeActions[i].Count;
                    totalValue += item.LikeActions[i].Action.Value * item.LikeActions[i].Count;
                }

                item.AverageLikeValue = totalValue / totalCount;
            }
        }

        function IsUnpublished(entry) {
            if (entry && entry.PublishDate) {
                return moment(entry.PublishDate).isAfter(moment());
            }

            return false;
        }

        function GetImageUrl(url) {
            if (url) {
                if (url.startsWith('/'))
                    url = url.substr(1, url.length - 1);

                return siteRootPath + url.replace('~', '');
            }
        }

        function NavigateToBlogEntry(entry) {
            return $state.go("base.modules.blogtitle", { title: entry.UrlRewrite }); // || entry.Id
        }

        function InitSlick(entry, overrideSlides) {
            entry.SlickLoaded = false;
            entry.SlickSettings = {
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: overrideSlides || 4,
                slidesToScroll: overrideSlides || 4,
                customPaging: function () {
                    return '<span class="biz-slick-dot biz-slick-square"></span>';
                },
                responsive: [{
                    breakpoint: 960,
                    settings: {
                        slidesToShow: vm.SlickOverrideResponsiveSlides || 2,
                        slidesToScroll: vm.SlickOverrideResponsiveSlides || 2
                    }
                }]
            }
            $timeout(function () {
                entry.SlickLoaded = true;
            });
        }

        function GetLikeActionsByValue(entry, positive) {
            var result = 0;
            for (var i = 0; i < entry.LikeActions.length; i++) {
                if ((positive && entry.LikeActions[i].Action.Value > 0) || (!positive && entry.LikeActions[i].Action.Value < 0)) {
                    result += entry.LikeActions[i].Count;
                }
            }
            return result;
        }

        function TotalLikeActions(entry) {
            var count = 0;
            for (var i = 0; i < entry.LikeActions.length; i++) {
                count += entry.LikeActions[i].Count;
            }
            return count;
        }

        function ExpandItem(item) {
            vm.GetRelatedBlogEntries(item);

            if (item.Expanded)
                return;

            if (vm.ExpandedItem)
                vm.ExpandedItem.Expanded = false;

            vm.ExpandedItem = item;
            vm.ExpandedItem.Expanded = true;
            window.scrollTo(0, 0);

            bizSocialShareService.loadedObject = item;
        }

        function GetRelatedBlogEntries(item) {
            if (!item.RelatedEntries) {
                blogService.GetRelatedBlogPosts(item.Id).then(GetRelatedBlogPostsSuccess);
            }

            function GetRelatedBlogPostsSuccess(response) {
                item.RelatedEntries = response.data;

                //Populate Images...
                for (var i = 0; i < item.RelatedEntries.length; i++) {
                    if (item.RelatedEntries[i].ContainerId > 0) {
                        item.RelatedEntries[i].Container = new container(item.RelatedEntries[i].Container);
                        var modules = item.RelatedEntries[i].Container.getModules("Image");
                        if (modules && modules.length > 0) {
                            item.RelatedEntries[i].ImageUrl = modules[0].Content.ImageUrl;
                        }
                        else {
                            var modules = item.RelatedEntries[i].Container.getModules("Video");
                            if (modules && modules.length > 0) {
                                if (item.RelatedEntries[i].ImageUrl)
                                    item.RelatedEntries[i].ImageUrl = modules[0].Content.VideoUrl.replace('~/', "") + ".jpg";
                                else
                                    item.RelatedEntries[i].ImageUrl = "https://img.youtube.com/vi/" + modules[0].Content.YoutubeId + "/0.jpg";
                            }
                        }
                    }
                }

                vm.InitSlick(item);
            }
        }


        function GetOneBlogEntry(entryId, entryTitle) {
            vm.AllItemsFetched = true;

            if (entryId > 0) {
                blogService.GetOneBlogEntry(entryId, false).then(GetOneBlogEntrySuccess);
            } else if (entryTitle) {
                blogService.GetOneBlogEntryByTitle(entryTitle, false).then(GetOneBlogEntrySuccess, GetOneBlogEntryError);
            }

            function GetOneBlogEntryError(err) {
                if (err.status == 401 || err.status == 404 || err.status == 500)
                    vm.NoAccess = true;
            }

            function GetOneBlogEntrySuccess(response) {
                var blogItem = response.data;
                vm.EntryId = blogItem.Id;
                bizContainerSettings.ContainerRefererObjectId = vm.EntryId;
                bizContainerSettings.ContainerRefererCreatedByUserId = blogItem.UserId;
                vm.BlogItems.push(blogItem);
                vm.ItemsFetched = true
                vm.GettingMoreItems = false;

                blogItem.Container = new container(blogItem.Container);
                bizEngageService.HandleContainer(blogItem.Container, blogItem.Id, bizEngageService.Types.Blog);

                vm.SelectedItem = blogItem;
                vm.ExpandItem(blogItem);

                var imageModules = vm.BlogItems[0].Container.getModules("IMAGE");
                var imageUrl = "";
                if (imageModules.length > 0 && imageModules[0].Content.ImageUrl.length > 0) {
                    imageUrl = imageModules[0].Content.ImageUrl;
                }

                var videoModules = vm.BlogItems[0].Container.getModules("VIDEO");
                var videoUrl = "";
                if (videoModules.length > 0) {
                    videoUrl = videoModules[0].Content.VideoUrl;
                }

                MetadataService.setMetaTags({
                    title: blogItem.SeoTitle || blogItem.Title,
                    description: blogItem.SeoDescription || blogItem.Description,
                    keywords: blogItem.SeoKeywords,
                    img: blogItem.ImageUrl || imageUrl,
                    video: videoUrl,
                    type: 'article',
                    canonicalPath: blogItem.CanonicalPath || '/blog/' + (blogItem.UrlRewrite || vm.EntryTitle),
                    excludeFromExternalIndex: blogItem.ExcludeFromExternalIndex,
					datePublished: blogItem.StartTimeUtc || blogItem.Created,
					dateModified: blogItem.Updated,
					author: blogItem.UserFullName,
					estimatedTimeInMinutes: blogItem.EstimatedTimeInMinutes
                });

                vm.GetBlogEntries(true);

                vm.GetSettings();
            }
        }

        function GetBlogEntries(ignoreLoader) {
            if (vm.TagSystemName) {
                GetTag(GetBlogEntriesLocal);
            } else {
                GetBlogEntriesLocal(ignoreLoader);
            }

            vm.SortMostCommented = SortMostCommented;
            vm.SortMostLiked = SortMostLiked;

            function SortMostCommented() {
                var items = angular.copy(vm.BlogItems);
                vm.BlogItemsCommented = items.sort(function (a, b) { return b.Comments.length - a.Comments.length }).slice(0, 6);
            }

            function SortMostLiked() {
                var items = angular.copy(vm.BlogItems);
                vm.BlogItemsLiked = items.sort(function (a, b) { return b.LikeValue - a.LikeValue }).slice(0, 6);
            }

            function GetBlogEntriesLocal(ignoreLoader) {
                var tagIds = vm.TagId ? [vm.TagId] : undefined;
                blogService.GetNewestBlogEntries(0, true, ignoreLoader, tagIds, -1).then(GetBlogEntriesSuccess);
                function GetBlogEntriesSuccess(response) {
                    vm.ItemsFetched = true;
                    vm.BlogItems = response.data;
                    vm.SortMostLiked();
                    vm.SortMostCommented();
                    vm.GettingMoreItems = false;
                    vm.BlogItemsToShow = vm.BlogItems.slice(0, vm.EntriesPerPage);
                    console.log(vm.BlogItemsToShow);
                    vm.AllItemsFetched = vm.TotalEntries > vm.BlogItems.length;

                    //Populate Images and description
                    for (var i = 0; i < vm.BlogItems.length; i++) {
                        if (vm.BlogItems[i].ContainerId > 0) {
                            vm.BlogItems[i].Container = new container(vm.BlogItems[i].Container);
                            var modules = vm.BlogItems[i].Container.getModules("Image");
                            if (modules && modules.length > 0) {
                                vm.BlogItems[i].ImageUrl = modules[0].Content.ImageUrl;
                            }
                            else {
                                var modules = vm.BlogItems[i].Container.getModules("Video");
                                if (modules && modules.length > 0) {
                                    if (vm.BlogItems[i].ImageUrl)
                                        vm.BlogItems[i].ImageUrl = modules[0].Content.VideoUrl.replace('~/', "") + ".jpg";
                                    else
                                        vm.BlogItems[i].ImageUrl = "https://img.youtube.com/vi/" + modules[0].Content.YoutubeId + "/0.jpg";
                                }
                            }

                            if (vm.BlogItems[i].Description == null || vm.BlogItems[i].Description == "") {
                                var modules = vm.BlogItems[i].Container.getModules("Text");
                                if (modules != null && modules.length > 0) {
                                    vm.BlogItems[i].Description = $filter('bizPlaceholders')(modules[0].Content.Text);
                                }
                            }
                        }
                        vm.InitSlick(vm.BlogItems[i], 2);
                    }
                    if (!vm.ExpandedItem && (vm.EntryId > 0 || vm.EntryTitle)) {
                        var entry;
                        if (vm.EntryId > 0) {
                            entry = vm.BlogItems.GetItemByValue('Id', vm.EntryId);
                        } else if (vm.EntryTitle) {
                            entry = vm.BlogItems.GetItemByValue('UrlRewrite', vm.EntryTitle);
                        }
                        if (!entry)
                            vm.GetOneBlogEntry(vm.EntryId, vm.EntryTitle);
                        else {
                            vm.EntryId = entry.Id;
                            vm.SelectedItem = entry;
                            vm.ExpandItem(entry);
                        }
                    }
                    else if (vm.TagId > 0 || vm.TagSystemName) {
                        GetTag();
                    }
                    else if (!vm.SelectedItem) {
                        vm.SelectedItem = vm.BlogItems[0];
                    }
                }
            }
        }

        function RedirectToUrlRewrite(id) {
            blogService.GetEntryUrlRewriteById(id).then(GetEntryUrlRewriteByIdCallback);

            function GetEntryUrlRewriteByIdCallback(response) {
                var urlRewrite = BizPartCoreHelpers.getResponseValue(response);
                $state.go("base.modules.blogtitle", { title: urlRewrite })
            }
        }

        angular.element(document).ready(function () {
            var id = ~~$stateParams.id;
            if (id > 0) {

                vm.RedirectToUrlRewrite(id);
                return;
            }

            if (vm.EntryTitle) {
                GetOneBlogEntry(vm.EntryId, vm.EntryTitle);
            }
            else {
                vm.GetBlogEntries();
            }

            $translate(['BLOG.META.TITLE', 'BLOG.META.DESCRIPTION']).then(function (translations) {
                MetadataService.setMetaTags({
                    title: translations['BLOG.META.TITLE'],
                    description: translations['BLOG.META.DESCRIPTION']
                })
            });
        });
    }
})(window.angular);
